import { motion } from "framer-motion";
import { LOGOS } from "@/brand";

const CHAPTERS = [
  {
    number: "001",
    title: "THE DEATH OF EASE",
    content:
      "Comfort is the silent killer of ambition. We forge garments for those who thrive in the friction of the night — crowned in concrete, refined in chaos.",
  },
  {
    number: "002",
    title: "RAW CHROME & CONCRETE",
    content:
      "Southern California sun burned through black ink and spray paint. Every thread carries the weight of Chicano lettering and metallic armor.",
  },
  {
    number: "003",
    title: "UNTOUCHABLE KINGS",
    content:
      "𝕮𝒳𝑀𝒳𝐼𝐼𝕸𝒪𝐵𝐁 ﾒ 𝔚𝒪𝑅𝐿𝒟𝒲𝐼𝒟𝐸 is not a label. It is a sworn brotherhood. No shortcuts, no compromises — the crown is earned, never given.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-chapters-section" className="relative mx-auto max-w-7xl px-4 sm:px-8 py-28 sm:py-40 concrete-grain">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 items-center mb-20">
        <div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            className="text-[10px] tracking-[0.45em] text-zinc-600 uppercase mb-4"
          >
            The Manifesto
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-5xl sm:text-7xl chrome-text uppercase"
          >
            Written in Ink &amp; Asphalt
          </motion.h2>
        </div>
        <motion.img
          src={LOGOS.campaign}
          alt="No Comfort — Unlimited Potential campaign artwork"
          data-testid="manifesto-campaign-art"
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="logo-blend w-full max-w-xs sm:max-w-sm border border-zinc-800/60 justify-self-center"
        />
      </div>

      <div className="flex flex-col">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.number}
            data-testid={`manifesto-chapter-${c.number}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-1 md:grid-cols-[140px_1fr_1.2fr] gap-4 md:gap-10 border-t border-zinc-800/70 py-12 items-baseline hover:bg-zinc-900/30 transition-colors duration-500 px-2 sm:px-4"
          >
            <span className="font-display text-5xl sm:text-6xl outline-text group-hover:-translate-y-1 transition-transform duration-500">
              {c.number}
            </span>
            <h3 className="font-display text-3xl sm:text-4xl tracking-wide chrome-text-bright uppercase">{c.title}</h3>
            <p className="text-xs sm:text-sm leading-loose text-zinc-400 max-w-xl">{c.content}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
